/**
 * Appvia Layout Module
 *
 * This module provides the custom Appvia layout for the Backstage app.
 * It overrides the default app layout with a custom flexbox layout.
 *
 * @packageDocumentation
 */

import {
  createFrontendModule,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import appPlugin from '@backstage/plugin-app';

const customAppLayout = appPlugin.getExtension('app/layout').override({
  factory: (originalFactory, context) => {
    // Call original factory to get the extension container
    const originalContainer = originalFactory();

    // Access inputs from context
    const nav = context.inputs.nav?.get(coreExtensionData.reactElement);
    const content = context.inputs.content?.get(coreExtensionData.reactElement);

    return [
      coreExtensionData.reactElement(
        <div
          className="min-h-screen flex flex-col"
          style={{ backgroundColor: 'var(--appvia-background-default)' }}
        >
          {nav}
          <main className="flex-grow">{content}</main>
        </div>,
      ),
      // Pass through other extension data from original container
      ...Array.from(originalContainer).filter(
        item => item.id !== 'core.reactElement',
      ),
    ];
  },
});

/**
 * Frontend module that provides the Appvia layout.
 *
 * This module targets the 'app' plugin and overrides the default layout
 * with a custom flexbox layout using Tailwind CSS classes.
 *
 * @public
 */
export const appviaLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [customAppLayout],
});
